package de.katoonerie.content

import androidx.compose.runtime.Composable
import de.katoonerie.components.Container
import de.katoonerie.components.Document
import de.katoonerie.components.Gradient
import de.katoonerie.components.Prose
import de.katoonerie.util.removeDoubleSlashes
import org.jetbrains.compose.web.attributes.ATarget
import org.jetbrains.compose.web.attributes.target
import org.jetbrains.compose.web.dom.A
import org.jetbrains.compose.web.dom.Br
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Img
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text

@Composable
fun Network() {
    Gradient {
        Container {
            Div(attrs = {
                classes("mx-auto", "flex", "flex-wrap")
            }) {
                Div(attrs = {
                    classes("lg:basis-2/3", "xl:basis-1/2", "p-4")
                }) {
                    Lisa()
                    ImagesLisaAndVera()
                    Vera()
                    ConsultanceEbner()
                    ConsultanceEnglert()
                    ConsultanceReis()
                }
                Div(attrs = {
                    classes("lg:basis-1/3", "xl:basis-1/2", "p-4")
                }) {
                    SideText()
                }
            }
        }
    }
}

@Composable
private fun Lisa() {
    Prose(attrs = { classes("mb-8") }) {
        P {
            Span(attrs = { classes("font-semibold", "text-lg") }) {
                Text("Dr. Elisabeth Hotze, StD‘ in i.R.,")
            }
            Br()
            Text("Fächer: Deutsch, Philosophie, Kunst, Katholische Religionslehre, Pädagogik.")
        }
        P {
            Text("Arbeitsgebiete:")
            Br()
            Text("Begabungsförderung und Inklusion, Entwicklung von Unterrichtsmaterialien")
        }
        P {
            Text("Promotion 2018 mit der Dissertation: Überlegungen zur Konstruktion heterogenitätstauglicher bibeldidaktischer Basistexte am Beispiel des digitalen Buches:")
            Br()
            A(
                attrs = { target(ATarget.Blank) },
                href = "https://duepublico2.uni-due.de/servlets/MCRFileNodeServlet/duepublico_derivate_00046668/DissElisabethHotze.pdf"
            ) {
                Document(attrs = { classes("w-5", "h-5", "mr-1", "inline") })
                Text("Der Weg des Paulus.")
            }
        }
    }
}

@Composable
private fun Vera() {
    Prose(attrs = { classes("mb-8") }) {
        P {
            Span(attrs = { classes("font-semibold", "text-lg") }) {
                Text("Vera Kappert-Hölter")
            }
            Br()
            Text("studierte Visuelle Kommunikation an der GH Essen, Folkwangschule, Diplom 1981.")
        }
        P {
            Text("Grafikerin,")
            Br()
            Text("Tätigkeit in einer PR- und Werbeagentur,")
            Br()
            Text("freiberufliche Illustratorin und Grafik-Designerin.")
        }
        P {
            Text("Sie arbeitete u.a. für die Stadt Essen,")
            Br()
            Text("den Weihnachtsmarkt Hattingen, für die Bistümer Essen, Münster, Aachen,")
            Br()
            Text("für die Funke-Gruppe sowie verschiedene Print-Medien.")
        }
    }
}

@JsModule("./dr-elisabeth-hotze.png")
@JsNonModule
external val lisaImgSrc: String

@JsModule("./vera-kappert-hoelter.png")
@JsNonModule
external val veraImgSrc: String

@Composable
private fun ImagesLisaAndVera() {
    Div(attrs = {
        classes("grid", "grid-cols-2", "gap-4", "mb-8", "md:w-2/3")
    }) {
        Img(src = lisaImgSrc.removeDoubleSlashes(), alt = "Dr. Elisabeth Hotze", attrs = {
            classes("border-2", "border-amber-50", "rounded-tl")
        })
        Img(src = veraImgSrc.removeDoubleSlashes(), alt = "Vera Kappert-Hölter", attrs = {
            classes("border-2", "border-amber-50", "rounded-tr")
        })
        Div(attrs = {
            classes("bg-lime-300", "text-slate-600", "border-2", "border-amber-50", "rounded-bl", "px-2", "py-1")
        }) {
            P(attrs = { classes("uppercase", "font-semibold", "text-md") }) {
                Text("Dr. Elisabeth Hotze")
            }
            P(attrs = { classes("leading-tight") }) {
                Text("Concept")
                Br()
                Text("Inhaltliche Gestaltung")
            }
        }
        Div(attrs = {
            classes("bg-yellow-300", "text-slate-600", "border-2", "border-amber-50", "rounded-br", "px-2", "py-1")
        }) {
            P(attrs = { classes("uppercase", "font-semibold", "text-md") }) {
                Text("Vera Kappert-Hölter")
            }
            P(attrs = { classes("leading-tight") }) {
                Text("Illustration")
                Br()
                Text("Grafik-Design")
            }
        }
    }
}

@JsModule("./prof-em-dr-martin-ebner.png")
@JsNonModule
external val ebnerImgSrc: String

@Composable
private fun ConsultanceEbner() {
    Div(attrs = {
        classes("grid", "grid-cols-3", "gap-4", "mb-8", "md:w-2/3")
    }) {
        Div(attrs = {
            classes(
                "col-span-2",
                "bg-slate-600",
                "text-amber-50",
                "border-2",
                "border-amber-50",
                "rounded-t",
                "px-2",
                "py-1"
            )
        }) {
            P(attrs = { classes("uppercase", "font-semibold", "text-md") }) {
                Text("Beratung")
            }
            P(attrs = { classes("leading-tight") }) {
                Text("Prof. em. Dr. Martin Ebner")
                Br()
                Text("Exegese des Neuen Testaments")
            }
        }
        Img(src = ebnerImgSrc.removeDoubleSlashes(), alt = "Prof. em. Dr. Martin Ebner", attrs = {
            classes("border-2", "border-amber-50", "rounded-b")
        })
    }
}

@JsModule("./prof-em-dr-rudolph-englert.png")
@JsNonModule
external val englertImgSrc: String

@Composable
private fun ConsultanceEnglert() {
    Div(attrs = {
        classes("grid", "grid-cols-3", "gap-4", "mb-8", "md:w-2/3")
    }) {
        Img(src = englertImgSrc.removeDoubleSlashes(), alt = "Prof. em. Dr. Rudolph Englert", attrs = {
            classes("border-2", "border-amber-50", "rounded-b")
        })
        Div(attrs = {
            classes(
                "col-span-2",
                "bg-slate-600",
                "text-amber-50",
                "border-2",
                "border-amber-50",
                "rounded-t",
                "px-2",
                "py-1"
            )
        }) {
            P(attrs = { classes("uppercase", "font-semibold", "text-md") }) {
                Text("Beratung")
            }
            P(attrs = { classes("leading-tight") }) {
                Text("Prof. em. Dr. Rudolph Englert")
                Br()
                Text("Praktische Theologie/ Religionspädagogik")
            }
        }
    }
}

@JsModule("./prof-dr-dr-oliver-reis.png")
@JsNonModule
external val oliverImgSrc: String

@Composable
private fun ConsultanceReis() {
    Div(attrs = {
        classes("grid", "grid-cols-3", "gap-4", "mb-8", "md:w-2/3")
    }) {
        Div(attrs = {
            classes(
                "col-span-2",
                "bg-slate-600",
                "text-amber-50",
                "border-2",
                "border-amber-50",
                "rounded-t",
                "px-2",
                "py-1"
            )
        }) {
            P(attrs = { classes("uppercase", "font-semibold", "text-md") }) {
                Text("Beratung")
            }
            P(attrs = { classes("leading-tight") }) {
                Text("Prof. Dr. Dr. Oliver Reis")
                Br()
                Text("Religionspädagogik unter besonderer Berücksichtigung von Inklusion")
            }
        }
        Img(src = oliverImgSrc.removeDoubleSlashes(), alt = "Prof. Dr. Dr. Oliver Reis", attrs = {
            classes("border-2", "border-amber-50", "rounded-b")
        })
    }
}

@Composable
private fun SideText() {
    Div(attrs = {
        classes("border-24", "border-blue-900", "bg-indigo-900", "text-amber-50")
    }) {
        Prose(attrs = { classes("prose-lg", "p-6") }) {
            Text(
                """
                Christinnen und Christen können den praktischen Gehalt ihres Glaubens kaum noch alltagstauglich ausdrücken.
                Dabei haben sie eine mitreißende Lebensperspektive – wenn sie aus ihrer dogmatischen ‚Tiefkühltruhe‘ herauskommen. Zum ‚grafischen Enteisen‘ krempeln wir, Lisa Hotze und Vera Hölter, fachlich unterstützt von Martin Ebner, Rudolf Englert und Oliver Reis, in der Katechetischen Cartoonerie die Ärmel hoch.
                Mit dem Zeichenstift setzen wir Theologie für alle ins Comic-Bild. Eigene Vorstellungen –  auch spirituelle  –  immer wieder in Frage zu stellen, regt an. Wir fangen ganz unten an – und bleiben auch dort.
                """.trimIndent()
            )
        }
    }
}
